// import { filter } from "cypress/types/bluebird";
import { ref, onMounted } from "vue";

export default function useAutoCompleteSelect(listProp, autocompleteType) {
  const search = ref("");
  const selectedItem = ref("");
  const arrowCounter = ref(0);
  const selectList = ref([]);
  const supportList = ref([]);
  const filteredList = ref([]);
  const isOpen = ref(false);
  const type = ref("");

  onMounted(() => {
    selectList.value = listProp;
    type.value = autocompleteType;
  });

  const toggleSelect = (open) => {
    isOpen.value = open || !isOpen.value;
  };

  const filterResults = () => {
    switch (type.value) {
      case "country":
        filteredList.value = selectList.value.filter(
          (item) =>
            item.name.toLowerCase().indexOf(search.value.toLowerCase()) > -1
        );
        break;
      case "phoneCountry":
        filteredList.value = selectList.value.filter(
          (item) =>
            item.name.toLowerCase().indexOf(search.value.toLowerCase()) > -1 ||
            (Object.getOwnPropertyDescriptor(item, "internationalCode") &&
              item.internationalCode.indexOf(
                search.value.replace("+", "").toLowerCase()
              ) > -1)
        );
        break;
      case "fiat":
        filteredList.value = selectList.value.filter(
          (item) =>  item.toLowerCase().indexOf(search.value.toLowerCase()) > -1
        );
        break;
      case "coin":
        filteredList.value = supportList.value.filter(
          (item) =>  item.coin_code.toLowerCase().indexOf(search.value.toLowerCase()) > -1 
                  || item.coin_name.toLowerCase().indexOf(search.value.toLowerCase()) > -1
        ).map(item => item.coin_code); 
        
        break;
      default:
        filteredList.value = selectList.value;
    }
  };


  const clearSearchFilters = () => {
    search.value = "";
    arrowCounter.value = 0;
  };

  const searchList = () => {
    filterResults();
    toggleSelect(true);
  };

  const setSearchValue = (item) => {
    if (Object.getOwnPropertyDescriptor(item, "name")) {
      selectedItem.value = item.name;
    } else {
      selectedItem.value = item;
    }

    clearSearchFilters();
    toggleSelect(false);
  };

  const goToNextEl = () => {
    if (arrowCounter.value < selectList.value.length) {
      arrowCounter.value += 1;
    }
  };

  const goToPreviousEl = () => {
    if (arrowCounter.value > 0) {
      arrowCounter.value -= 1;
    }
  };
  const selectEl = () => {
    const item = filteredList.value[arrowCounter.value];
    setSearchValue(item);
  };

  const selectFirstItem = () => {
    if (filteredList.value.length === 0) {
      return;
    }

    const item = filteredList.value[0];
    setSearchValue(item);
  };

  const updateCurrentList = (newListItems, supportItems = []) => {
    selectList.value = newListItems;
    if (supportItems.length > 0) {
      supportList.value = supportItems;
    }
  };

  const handleBlur = (e) => {
    if (!e.relatedTarget && isOpen.value) {
      toggleSelect(false);
      clearSearchFilters();
    }
  };

  

  return {
    isOpen,
    search,
    selectedItem,
    arrowCounter,
    searchList,
    filteredList,
    goToNextEl,
    selectEl,
    goToPreviousEl,
    setSearchValue,
    selectFirstItem,
    toggleSelect,
    updateCurrentList,
    handleBlur,
  };
}
